<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P4BlAg/tc-custom/9781625846129.jpg?1705026246223" alt="This image is the cover for the book Oregon Sports Stories, Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oregon Sports Stories, Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>Oregon has its share of playmakers, dramatic finishes and legendary coaches. With humor and insight, Oregon native and longtime sportswriter Bob Robinson relates highlights from six decades of coverage throughout the state. Blazermania overruns the Rose City as the Trail Blazers take down the favored Philadelphia 76ers in 1977. Oregon State's Orange Express, coached by Ralph Miller, captivates the state in 1981 before a shocking stumble in the NCAA playoffs. University of Oregon's Bill Dellinger kickstarts the school's distance-running tradition with a stunning win in 1954. In the 1970s, Mouse Davis performs coaching magic at Portland State with his Run and Shoot football offense. In these twenty essays, Robinson offers a unique, behind-the-scenes account of some of Oregon's greatest sports moments and game-changing personalities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Robinson
      </h2>
      
      <p class="authorDescription body article">After graduating from the University of Oregon's School of Journalism, Bob Robinson's newspaper career took him to the Eugene Register-Guard, the Salem Capital Journal, and finally The Oregonian, where he retired after nearly forty years. Robinson's awards include Oregon Sports Writer of the Year following his coverage of the 1977 NBA Finals.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15afd54f